export default __webpack_public_path__ + "images/gardencenter-icon.25b3c8440c2f30c6104aa2271ccdcf8a.svg";